import BaseStore from 'hljd/esm/SearchBar/store'
import Api from '@api/team'

class Store extends BaseStore {
  $listApi = Api.inviteList
  $pageSizeKey = 'perPage'

  agreeJoinGroup = async (inviteId, agree) => {
    const { success } = await Api.agreeJoinGroup({ inviteId, agree })
    if (success) {
      this.$getList()
    }
  }
}

export default Store
